import axios from "axios";
import type { SubmitPayload } from "../types";

const API_BASE = (import.meta as any).env?.PROD ? "" : "";

export const api = axios.create({
  baseURL: `${API_BASE}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("snimok-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Унифицированный submit от TWA → backend. Бек запускает соответствующую generation
 * fire-and-forget; ответ может прийти до начала генерации — не ждём результат, TWA
 * закрывается сразу после успешного submit.
 */
export async function submit(payload: SubmitPayload): Promise<void> {
  await api.post("/twa/submit", payload);
}
